import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";

import { ProfileDialogComponent } from "../profile";
import { IUser } from "../_models";
import { StorageService, AuthenticationService, MediaWatcherService } from "../_services";
import { AppGlobals } from "../app.globals";

@Component({
    templateUrl: "home.component.html",
    styleUrls: ["home.component.css"]
})
export class HomeComponent implements OnInit, OnDestroy {
    currentUser: IUser;
    currentUserSubscription: Subscription;
    mediaWatcherSubscription: Subscription;
    isMobile = false;

    constructor(private authenticationService: AuthenticationService, private storageService: StorageService, public dialog: MatDialog, private mediaWatcherService: MediaWatcherService, private appGlobals: AppGlobals) {
        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;
        });

        //update authentication user value every time the session is refreshed
        this.storageService.currentUser.subscribe((user) => {
            if (user)
                this.authenticationService.currentUserValue = user;
        });
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.appGlobals.pageTitleValue = "Home";
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    accountProfile() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = "60%";

        dialogConfig.data = {
            currentUser: this.currentUser
        };

        this.dialog.open(ProfileDialogComponent, dialogConfig);
    }
}